/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint weekend adjustments — Sprint races and sprint qualifying score separately per the official weekend format rules.`)
};

const es_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de fin de semana sprint — Las carreras sprint y la clasificación sprint se puntuan por separado según las reglas oficiales del formato de fin de semana.`)
};

const de_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint-Wochenend-Anpassungen — Sprintrennen und Sprint-Qualifying werden gemäß den offiziellen Wochenendformat-Regeln separat bewertet.`)
};

const nl_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprintweekend-aanpassingen — Sprintraces en sprintkwalificatie scoren apart volgens de officiële weekendformaatregels.`)
};

const fr_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustements week-end sprint — Les courses sprint et qualifications sprint sont notées séparément selon les règles du format officiel du week-end.`)
};

const it_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adeguamenti weekend sprint — Le gare sprint e le qualifiche sprint hanno punteggi separati secondo le regole ufficiali del formato weekend.`)
};

const pt_br2_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de fim de semana sprint — Corridas sprint e classificatória sprint pontuam separadamente conforme as regras oficiais do formato de fim de semana.`)
};

const pt_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de fim de semana sprint — Corridas sprint e qualificação sprint são pontuadas separadamente conforme as regras oficiais de formato de fim de semana.`)
};

const ja_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スプリントウィークエンド調整 — スプリントレースとスプリント予選は公式ウィークエンドフォーマットルールに従い別々にスコアリング。`)
};

const zh_about_scoring_sprint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲刺周末调整 — 冲刺赛和冲刺排位赛按照官方周末格式规则分别计分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_scoring_sprint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_scoring_sprint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_scoring_sprint", locale)
	if (locale === "en") return en_about_scoring_sprint(inputs)
	if (locale === "es") return es_about_scoring_sprint(inputs)
	if (locale === "de") return de_about_scoring_sprint(inputs)
	if (locale === "nl") return nl_about_scoring_sprint(inputs)
	if (locale === "fr") return fr_about_scoring_sprint(inputs)
	if (locale === "it") return it_about_scoring_sprint(inputs)
	if (locale === "pt-BR") return pt_br2_about_scoring_sprint(inputs)
	if (locale === "pt") return pt_about_scoring_sprint(inputs)
	if (locale === "ja") return ja_about_scoring_sprint(inputs)
	return zh_about_scoring_sprint(inputs)
};